import "./Footer.css";

import { BsTelegram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";

function Footer() {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Aklil Solomon
      </a>

      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experiance">Experience</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a target="_blank" href="https://github.com/akuna444" rel="noreferrer">
          <FaGithub />
        </a>
        <a
          target="_blank"
          href="https://linkedin.com/in/aklil-solomon"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
        <a target="_blank" href="https://t.me/akuna444" rel="noreferrer">
          <BsTelegram />
        </a>
      </div>

      <div className="footer__footer">
  <small>Aklil Solomon ©{new Date().getFullYear()}</small>
</div>

    </footer>
  );
}

export default Footer;
